/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CommissionRateInitRespVo } from './CommissionRateInitRespVo';
import {
    CommissionRateInitRespVoFromJSON,
    CommissionRateInitRespVoFromJSONTyped,
    CommissionRateInitRespVoToJSON,
    CommissionRateInitRespVoToJSONTyped,
} from './CommissionRateInitRespVo';

/**
 * 
 * @export
 * @interface ResponseCommissionRateInitRespVo
 */
export interface ResponseCommissionRateInitRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseCommissionRateInitRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseCommissionRateInitRespVo
     */
    message?: string;
    /**
     * 
     * @type {CommissionRateInitRespVo}
     * @memberof ResponseCommissionRateInitRespVo
     */
    data?: CommissionRateInitRespVo;
}

/**
 * Check if a given object implements the ResponseCommissionRateInitRespVo interface.
 */
export function instanceOfResponseCommissionRateInitRespVo(value: object): value is ResponseCommissionRateInitRespVo {
    return true;
}

export function ResponseCommissionRateInitRespVoFromJSON(json: any): ResponseCommissionRateInitRespVo {
    return ResponseCommissionRateInitRespVoFromJSONTyped(json, false);
}

export function ResponseCommissionRateInitRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseCommissionRateInitRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : CommissionRateInitRespVoFromJSON(json['data']),
    };
}

export function ResponseCommissionRateInitRespVoToJSON(json: any): ResponseCommissionRateInitRespVo {
    return ResponseCommissionRateInitRespVoToJSONTyped(json, false);
}

export function ResponseCommissionRateInitRespVoToJSONTyped(value?: ResponseCommissionRateInitRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': CommissionRateInitRespVoToJSON(value['data']),
    };
}

